export class ResetPasswordRequest {
  key: string;
  newPassword: string;
  confirmPassword: string;

  constructor(key: string, newPassword: string, confirmPassword: string) {
    this.key = key;
    this.newPassword = newPassword;
    this.confirmPassword = confirmPassword;
  }
}
